<template>
    <div class="head_navigation">
        <logo color="#000"/>
        <menu_top class="menu_top"/>
        <language class="language"/>
        <search class="search"/>
        <banner class="banner"/>
        <menu_middle class="menu_middle"/>
    </div>
</template>


<script>
import logo from './logo.vue'
import menu_top from './menu_top.vue'
import language from './language.vue'
import banner from './banner.vue'
import menu_middle from './menu_middle.vue'
import search from './search.vue'



export default {
    components: {
        logo,
        menu_top,
        language,
        banner,
        menu_middle,
        search
    }
}
</script>

<style scoped>

    .head_navigation {
        margin: 0 auto;
        position: relative;
        user-select: none;
    }
    
    .language,.search,.menu_top,.banner,.menu_middle {
        position: absolute;
    }

    @media screen and (max-width: 768px){
        .head_navigation {
            width: 100%;
            height: 100.165vw;
        }

        .language {
            top: 0.9vw;
            right:6.5vw;
        }

        .menu_top {
            top: -1.5vw;
            right: 0;
        }

        .search {
            top: 0.9vw;
            right: 26.5vw;
        }

        .banner {
            top: 7.6vw;
            width: 100%;
            height: 60vw;
        }

        .menu_middle {
            top: 67.6vw;
            width: 100%;
            height: 20vw;
        }
    }

    @media screen and (max-width: 1080px) and (min-width: 768px){
        .head_navigation {
            width: 100%;
            height: 8vw;
        }

        .language {
            top: 1.6vw;
            right: 7vw;
        }

        .menu_top {
            top: 1.2vw;
            right: 0;
        }

        .search {
            top: 1.5vw;
            right: 24.5vw;
        }

        .banner {
            top: 8vw;
            width: 100%;
            height: 30vw;
        }

        .menu_middle {
            top: 38vw;
            width: 100%;
            height: 16vw;
        }
    }

    @media (min-width: 1080px) {
        .head_navigation {
            width: 7.711rem;
        }

        .menu_top {
            top: 0;
            left: 2.2rem;
        }

        .language {
            top: 0;
            right: 0;
        }

        .search {
            top: 2.397rem;
            right: 0;
            width: 1.52rem;
            height: 0.386rem;
            z-index: 9;
        }
        .menu_middle {
            top: 2.4rem;
            width: 6.46rem;
        }

        .banner {
            top: 0.4rem;
            left: 0;
            height: 2.5rem;
            width: 7.711rem;
        }

    }

</style>